// Vendors
import $ from 'jquery';

$('.team-member-card').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  infinite: true,
  fade: true,
  asNavFor: '.team-member-slider',
  nextArrow:
    '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="fa fa-arrow-right"></i></button>',
  prevArrow:
    '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="fa fa-arrow-left"></i></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        adaptiveHeight: true,
      }
    }
  ]
});

$('.team-member-slider').slick({
  slidesToScroll: 1,
  asNavFor: '.team-member-card',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite: false
});

// Populate and open the shared bio modal from the tapped slide's content
$(document).on('click', '[data-bio-trigger]', function () {
  const slide = $(this).closest('.slider-content');
  const name = slide.find('.member-name').text().trim();
  const role = slide.find('.member-role').text().trim();
  const bio = slide.find('.member-bio').html();
  const modal = $('#modal-team-bio');

  modal.find('[data-bio-name]').text(name);
  modal.find('[data-bio-title]').text(role);
  modal.find('[data-bio-body]').html(bio);
  modal.trigger('modal:show');
});
